<!-- 环保-创发大会 -->
<template>
  <div class="hb-copy-div">
    <div class="hb-copy-text">
      <span class="hb-copy-text-1">复制链接</span>后在手机浏览器或PC浏览器中登录使用该功能
    </div>
    <div class="copyBtn"
      v-clipboard:copy="copyUrl" 
      v-clipboard:success="copy" 
      v-clipboard:error="onError">
      <span class="iconfont copyicon icon-fuzhilianjie"></span>
      <div class="copy-btn-text">复 制 链 接</div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      copyUrl: 'http://www.caepi.org.cn/cidepi/'
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    copy() {
      this.$Toast.success('复制成功');
    },
    onError() {
      this.$Toast.success('复制失败');
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.hb-copy-div {
  background-color: #228F43;
  height: 100vh;
  text-align: center;
}
.hb-copy-text {
  width:70%;
  font-size: 15px;
  font-family:PingFangSC-Light,PingFang SC;
  font-weight:300;
  color: #ffffff;
  margin: 0 auto;
  padding-top: 125px;
  margin-bottom: 50px;
}
.hb-copy-text-1 {
  font-size:15px;
  font-family:PingFangSC-Light,PingFang SC;
  font-weight:600;
  color: #ffffff;
}
.copyBtn {
  margin: 0 auto;
  text-align: center;
  width:80%;
  height:44px;
  line-height: 44px;
  border-radius: 22px;
  border:1px solid #ffffff;
}
.copyicon {
  line-height: 44px;
  display: inline-block;
  width:28px;
  height:28px;
  color:#ffffff;
}
.copy-btn-text {
  margin-left: 12px;
  line-height: 44px;
  display: inline-block;
  font-size:17px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:#ffffff;
  letter-spacing:3px;
}
</style>
